<h3>Detalle</h3>
<form [formGroup]="staffDetailForm">
    <div *ngIf="_staffCountService.showDetailPanel==true" class="field-loop">
        <div class="five-view date-pick">
            <mat-label>Desde</mat-label>
            <p>{{staffDetail?.desde|date: 'dd/MM/yyyy'}}</p>
        </div>
        <div class="five-view date-pick">
            <mat-label>Hasta</mat-label>
            <p>{{staffDetail?.hasta|date: 'dd/MM/yyyy'}}</p>
        </div>
        <div class="three-view">
            <mat-label><strong>Total</strong></mat-label>
            <mat-form-field class="example-full-width">
                <input matInput min="0" pattern="[0-9]+"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    formControlName="plantilla" (blur)="updateDetail()" [ngModel]="staffDetail?.plantilla">
            </mat-form-field>
        </div>
        <h4>Género</h4>
        <div class="five-view">
            <mat-label>Hombres</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput min="0" pattern="[0-9]+"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    formControlName="hombre" (blur)="updateDetail()" [ngModel]="staffDetail?.hombre">
            </mat-form-field>
        </div>
        <div class="five-view">
            <mat-label>Mujeres</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput min="0" pattern="[0-9]+"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    formControlName="mujer" (blur)="updateDetail()" [ngModel]="staffDetail?.mujer">
            </mat-form-field>
        </div>
        <h4>Edad</h4>
        <div class="five-view">
            <mat-label>18 a 30</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput min="0" pattern="[0-9]+"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    formControlName="edad18" (blur)="updateDetail()" [ngModel]="staffDetail?.edad18">
            </mat-form-field>
        </div>
        <div class="five-view">
            <mat-label>31 a 40</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput min="0" pattern="[0-9]+"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    formControlName="edad31" (blur)="updateDetail()" [ngModel]="staffDetail?.edad31">
            </mat-form-field>
        </div>
        <div class="five-view">
            <mat-label>41 a 50</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput min="0" pattern="[0-9]+"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    formControlName="edad41" (blur)="updateDetail()" [ngModel]="staffDetail?.edad41">
            </mat-form-field>
        </div>
        <div class="five-view">
            <mat-label>51 a 60</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput min="0" pattern="[0-9]+"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    formControlName="edad51" (blur)="updateDetail()" [ngModel]="staffDetail?.edad51">
            </mat-form-field>
        </div>
        <div class="five-view">
            <mat-label>Más de 60</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput min="0" pattern="[0-9]+"
                    oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
                    formControlName="edad61" (blur)="updateDetail()" [ngModel]="staffDetail?.edad61">
            </mat-form-field>
        </div>
    </div>
</form>